import React from "react";

const Footer = (props) => {
  return (
    <>
      <div className="page">{props.children}</div>
    </>
  );
};

export default Footer;
